// extracted by mini-css-extract-plugin
export default {"container":"MaybeNextTime_container__p-tVB","spanStyle":"MaybeNextTime_spanStyle__9DXpF","pic":"MaybeNextTime_pic__pY-2m","fadeIn":"MaybeNextTime_fadeIn__BZNyz"};